import { render, staticRenderFns } from "./mtl-add-child.vue?vue&type=template&id=61e17293"
import script from "./mtl-add-child.vue?vue&type=script&lang=js"
export * from "./mtl-add-child.vue?vue&type=script&lang=js"
import style0 from "./mtl-add-child.vue?vue&type=style&index=0&id=61e17293&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports